<template>
  <section class="banner-impresoras">
    <div class="overlay"></div>
    <div class="banner-content">
      <h1 class="titulo-principal">
        Bienvenido a <span class="resaltado">Jean Print</span>
      </h1>
      <h2 class="subtitulo">🖨️ Área de Impresoras y Soluciones de Impresión</h2>
      <p class="descripcion">
        Expertos en <span class="typed-text">{{ textoActual }}</span><span class="cursor">|</span>
      </p>
      <a
        href="https://wa.me/584125696219?text=Hola%20Jean%20Print,%20quiero%20información%20sobre%20tus%20servicios%20de%20impresión."
        target="_blank"
        class="btn-whatsapp"
      >
        📲 Contáctanos en WhatsApp
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "BannerImpresoras",
  data() {
    return {
      textos: [
        "Instalación y configuración de impresoras",
        "Mantenimiento preventivo y correctivo",
        "Recarga y reciclaje de cartuchos",
        "Soluciones de impresión empresarial",
        "Diagnóstico de fallas y reparación técnica",
      ],
      textoActual: "",
      indexTexto: 0,
      indexLetra: 0,
      borrando: false,
    };
  },
  mounted() {
    this.escribirTexto();
  },
  methods: {
    escribirTexto() {
      const texto = this.textos[this.indexTexto];

      if (!this.borrando) {
        this.textoActual = texto.substring(0, this.indexLetra + 1);
        this.indexLetra++;
        if (this.indexLetra === texto.length) {
          this.borrando = true;
          setTimeout(this.escribirTexto, 1500);
          return;
        }
      } else {
        this.textoActual = texto.substring(0, this.indexLetra - 1);
        this.indexLetra--;
        if (this.indexLetra === 0) {
          this.borrando = false;
          this.indexTexto = (this.indexTexto + 1) % this.textos.length;
        }
      }

      setTimeout(this.escribirTexto, this.borrando ? 60 : 120);
    },
  },
};
</script>

<style scoped>
.banner-impresoras {
  position: relative;
  height: 100vh;
  background: url("@/assets/Img/Banners/impresora-profesional.jpg") no-repeat center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 0;
}

.banner-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
  padding: 2rem;
  animation: fadeIn 2s ease-in-out;
}

.titulo-principal {
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 0 4px 8px rgba(0,0,0,0.6);
  animation: slideInDown 1.5s ease-out;
}

.resaltado {
  color: #00f2ff;
  text-shadow: 0 0 15px rgba(0, 242, 255, 0.9);
}

.subtitulo {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #ddd;
  animation: fadeInUp 2s ease-in-out;
}

.descripcion {
  font-size: 1.2rem;
  margin-bottom: 2rem;
}

.typed-text {
  color: #00f2ff;
  font-weight: bold;
}

.cursor {
  display: inline-block;
  width: 3px;
  background: #00f2ff;
  margin-left: 2px;
  animation: blink 0.8s infinite;
}

.btn-whatsapp {
  display: inline-block;
  background: #25d366;
  color: #fff;
  padding: 0.8rem 1.6rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s ease, background 0.3s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.btn-whatsapp:hover {
  background: #20b954;
  transform: scale(1.1);
}

/* Animaciones */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideInDown {
  from { transform: translateY(-80px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes fadeInUp {
  from { transform: translateY(80px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

@keyframes blink {
  0%, 50%, 100% { opacity: 1; }
  25%, 75% { opacity: 0; }
}
</style>
